import { Group, ImageMantine, Modal, ModalProps, Stack, Title } from 'ui';
import { LogoGBSmallBlue } from 'ui/Icons';

import { useBreakPoints } from '../../../../hooks/useBreakPoints';
import { CopyLinkGroup } from '../../../molecules/CopyLink/CopyLink';

interface ShareModalProps extends ModalProps {
  causeName?: string;
  link: string;
  type?: 'cause' | 'product' | 'campaign' | 'referral' | 'event';
  imgSrc?: string;
  title?: string;
  description?: string;
}

export const ShareModal = ({
  opened,
  onClose,
  causeName,
  link,
  type = 'cause',
  imgSrc,
  title,
  description,
}: ShareModalProps) => {
  const { isSmallScreen } = useBreakPoints();

  return (
    <Modal.Root opened={opened} onClose={onClose}>
      <Modal.Overlay />
      <Modal.Content>
        <Modal.Header bg="slate" p="lg" style={{ alignItems: 'flex-start' }}>
          <Group>
            {imgSrc ? (
              <ImageMantine src={imgSrc} w={48} h={48} radius={12} />
            ) : (
              <LogoGBSmallBlue w={48} h={48} radius={12} p="xs" bg="white" fit="contain" />
            )}

            <Modal.Title fz="lg" c="white" tt="capitalize">
              {title ?? `Share This ${type}`}
            </Modal.Title>
          </Group>
          <Modal.CloseButton c="white" variant="transparent" />
        </Modal.Header>
        <Modal.Body p="lg">
          <Stack gap="lg">
            <Title order={3}>
              {description ??
                `Share this ${
                  type === 'cause' || type === 'referral' ? 'link' : type
                } with friends to
                support ${type === 'referral' ? 'your favorite causes' : causeName}`}
            </Title>
            <CopyLinkGroup link={link} direction={isSmallScreen ? 'column' : 'row'} />
          </Stack>
        </Modal.Body>
      </Modal.Content>
    </Modal.Root>
  );
};
